import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateCountryAccessMutation } from "../graphql/mutations";
import type {
  UpdateCountryAccessMutationType,
  UpdateCountryAccessMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateCountryAccessMutation = (
  options?: MutationHookOptions<
    UpdateCountryAccessMutationType,
    UpdateCountryAccessMutationVariablesType
  >
) => {
  return useMutation<
    UpdateCountryAccessMutationType,
    UpdateCountryAccessMutationVariablesType
  >(UpdateCountryAccessMutation, options);
};
